module.exports = __webpack_public_path__ + "img/ATRC Platform - Privacy Policy -1.fce24a93.png";